import {
	DESTROY_APP_STATUSES,
	RECEIVE_STATUS,
	RECEIVE_NEXT_PROVIDER_ID,
	RECEIVE_NEXT_PROVIDER_NAME,
	RECEIVE_NEXT_PROVIDER_AUTOSUBMIT,
	SET_COMPLETED_APP_STATUS_FIELDS,
} from './constants';

const destroyAllStatuses = () => ({
	type: DESTROY_APP_STATUSES,
});

const receiveStatus = applicationStatuses => ({
	type: RECEIVE_STATUS,
	applicationStatuses,
});

const receiveNextProviderId = nextProviderId => ({
	type: RECEIVE_NEXT_PROVIDER_ID,
	nextProviderId,
});

const receiveNextProviderName = nextProviderName => ({
	type: RECEIVE_NEXT_PROVIDER_NAME,
	nextProviderName,
});

const receiveNextProviderAutoSubmit = nextProviderAutoSubmit => ({
	type: RECEIVE_NEXT_PROVIDER_AUTOSUBMIT,
	nextProviderAutoSubmit,
});

const setCompletedAppStatusFields = (completedAppStatusTitle, completedAppStatusText) => ({
	type: SET_COMPLETED_APP_STATUS_FIELDS,
	completedAppStatusTitle,
	completedAppStatusText,
});

export {
	destroyAllStatuses,
	receiveStatus,
	receiveNextProviderId,
	receiveNextProviderName,
	receiveNextProviderAutoSubmit,
	setCompletedAppStatusFields,
};
